import { render } from "./RechargePayPal.vue?vue&type=template&id=dbaf453e&scoped=true&ts=true"
import script from "./RechargePayPal.vue?vue&type=script&lang=ts"
export * from "./RechargePayPal.vue?vue&type=script&lang=ts"

import "./RechargePayPal.vue?vue&type=style&index=0&id=dbaf453e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbaf453e"]])

export default __exports__